import React from 'react';
import Navigation from '../tulote/Navigation';
import SubscriptionSection from '../tulote/SubscriptionSection';
import CallToAction from '../tulote/CallToAction';
import Footer from '../tulote/Footer';
import ThemeTogglerTwo from '../tulote/ThemeTogglerTwo';
import CadAssistantFloat from '../tulote/CadAssistantFloat';
import { ThemeProvider } from '../ThemeProvider';

function PlanesPage() {
  return (
    <ThemeProvider>
      <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors">
        {/* Navigation */}
        <Navigation />

        {/* Subscription Plans Section */}
        <section id="planes">
          <SubscriptionSection />
        </section>

        {/* Call to Action */}
        <CallToAction />

        {/* Footer */}
        <Footer />

        {/* CAD Assistant Float */}
        <CadAssistantFloat />

        {/* Theme Toggle Button */}
        <div className="fixed bottom-6 right-6 z-50 hidden sm:block">
          <ThemeTogglerTwo />
        </div>
      </div>
    </ThemeProvider>
  );
}

export default PlanesPage;
